import Joi from 'joi';

import { ProductsSliderBubblesProps } from './models';

const stringRequired = Joi.string().required();
const stringOptional = Joi.string().optional();
const numberRequired = Joi.number().required();
const numberOptional = Joi.number().optional();
const uriOptional = Joi.string().uri().optional();

const decorationSchema = {
  image: stringRequired,
  size: numberRequired,
  top: stringOptional,
  left: stringOptional,
  right: stringOptional,
  bottom: stringOptional,
  dur: numberRequired,
  delay: numberRequired,
  zIndex: numberOptional,
};

const optionalDecorationSchema = Joi.array().items(decorationSchema).min(1).optional();

const itemSchema = {
  title: stringRequired,
  mainImage: stringRequired,
  mainImageAlt: stringRequired,
  link: uriOptional,
  bubble: stringOptional,
  decorations: optionalDecorationSchema,
  bubbleBG: stringRequired,
};

const requiredItemSchema = Joi.array().items(itemSchema).min(1).required();

export const productsSliderBubblesSchema = Joi.object<ProductsSliderBubblesProps>({
  title: stringOptional,
  items: [requiredItemSchema],
}).options({ stripUnknown: true });
